import { Field, NumericInput } from 'Components/Core';
import withInjectedProps from 'Components/Core/InjectedPropsContext/withInjectedProps';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import React from 'react';

let AsOvenSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <ListFieldSection>
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="oven" name={`SampleOven`} />
        <Field input={<NumericInput />} name={`DryingTemperature`} />
      </ListFieldSection>
    </>
  );
};

AsOvenSection = withInjectedProps(AsOvenSection);

export { AsOvenSection };
export default AsOvenSection;
